<template>
  <div id="main" class="bg-grey-4 no-shadow">
    <div class="row box">
      <div class="col-lg-2 col-12 offset-lg-2 side-1 center flex-column">
        <div class="logo">
          <b><span class="orange-logo">multi</span><span class="blue-logo">cargo</span></b>
        </div>
        <br>
        <p>Velocidade e precisão, para inovar e acelerar!</p>
      </div>
      <div class="col-6 col-lg-2 side-2 center flex-column">
        <b><p>Saiba mais</p></b>
        <span class="span">Home Multicargo</span>
        <!-- <span class="span">O que é</span>
        <span class="span">Ajuda</span> -->
      </div>
      <div class="col-6 col-lg-2 side-3 flex-column">
        <b><p>Mídias sociais</p></b>
            <span class="span"> <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/multicargo.brasil/">Facebook</a></span>
            <!-- <span class="span">Instagram</span> -->
      </div>
      <div class="col-12 col-lg-2 side-4 flex-column center" style="opacity: 0.9;">
        <b><p>Entre em contato</p></b>
        <div class="font-contact">
          <q-icon size="1.5rem" name="domain" class="space-icon"/>
          <span>R. Santos Dumont, 1277 - sobreloja - Zona 03, Maringá - PR, 87050-100</span>
        </div>
        <div class="font-contact">
          <q-icon size="1.5rem" name="contact_support" class="space-icon" />
          <span>(44) 3013-7800</span>
        </div>
        <div class="font-contact">
          <q-icon size="1.5rem" name="mail_outline" class="space-icon"/>
          <span>multicargo@multicargo.io</span>
        </div>
      </div>
    </div>
    <div class="text-center bg-grey-4" style="background-color: #7c7c7c; font-size: 70%; padding: 0.7rem 0;">
      <span>Accellog - 2018 - Todos os direitos reservados</span>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

#main{
  font-family: 'Nunito', sans-serif !important;
  color: #797979;
}
.box{
  padding: 3rem 0;
  font-size: 90%;
}
.side-1{
  padding-left: 2rem;
}
.side-2{
  padding-left: 2rem;
}
.side-3{
  padding-left: 2rem;
}
.side-4{
  padding-left: 2rem;
}
.space-icon{
  margin-right: 5px;
}
.flex-column{
  display: flex;
  flex-direction: column;
}
.span{
  margin-bottom: 0.7rem;
}
.span:hover{
  text-decoration: underline;
  cursor: pointer;
}
.orange-logo{
  color: #F79520;
}
.blue-logo{
  color: #326394;
}
.logo {
  font-family: 'Nunito', sans-serif !important;
  font-size: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.font-contact{
  margin-bottom: 5px;
  font-size: 90%
}
a{
  text-decoration: none;
  color: #797979;
}
@media only screen and (max-width: 640px) {
 .logo {
    font-family: 'Nunito', sans-serif !important;
    font-size: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .side-1{
    padding-left: 0;
  }
  .side-2{
    padding-left: 2rem;
  }
  .side-3{
    padding-left: 0rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .side-4{
    padding-top: 0.5rem;
    padding-left: 2rem;
    padding-right: 2rem;
    text-align: center;
  }
  .center{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
